import {Options as StringifyOptions, stringify} from 'csv-stringify/browser/esm/sync';
import {Options as ParseOptions, parse} from 'csv-parse/browser/esm/sync';
import {ArrayUtils} from "@shared/util/collections/collection-utils";


export class CsvUtils {

  static stringifyToSingleLine(items: (string | number)[] | null, options?: StringifyOptions): string | null {
    if (items?.length) {
      const csvData = stringify([items], options);
      const lastCharIndex = csvData.length - 1;
      return csvData.charAt(lastCharIndex) === '\n' ? csvData.substring(0, lastCharIndex) : csvData;
    }
    return null;
  }

  static parseAsSingleLine(csvText: string | null, options?: ParseOptions): string[] | null {
    return csvText
      // when line breaks present in input string, multiple arrays will be returned
      // flatten all arrays into a single 1-D array, refer to test specs for more information
      ? ArrayUtils.flatten(parse(csvText, options))
      : null;
  }

}
